import { Route, Routes } from 'react-router-dom'

import AgencyEdit from './screens/Agencies/screens/Edit'
import AgencyList from './screens/Agencies/screens/List'
import ApiLogList from './screens/ApiLogs/screens/List'
import AssetLibraryList from './screens/Libraries/screens/AssetLibraryList'
import BrandEdit from './screens/Brands/screens/Edit'
import BrandGroupEdit from './screens/BrandGroups/screens/Edit'
import BrandGroupList from './screens/BrandGroups/screens/List'
import BrandList from './screens/Brands/screens/List'
import BrandThemeList from './screens/BrandThemes/screens/List'
import CampaignEdit from './screens/Campaigns/screens/Edit'
import CampaignList from './screens/Campaigns/screens/List'
import FontFamilyList from './screens/FontFamilies/screens/List'
import GeoCountryEdit from './screens/GeoCountries/screens/Edit'
import GeoCountryList from './screens/GeoCountries/screens/List'
import GeoSuburbList from './screens/GeoSuburbs/screens/List'
import ImageLibraryList from './screens/Libraries/screens/ImageLibraryList'
import InvoiceEdit from './screens/Invoices/screens/Edit'
import InvoiceList from './screens/Invoices/screens/List'
import LoginSessionList from './screens/LoginSessions/screens/List'
import NotificationEdit from './screens/Notifications/screens/Edit'
import NotificationList from './screens/Notifications/screens/List'
import OrderBundleEdit from './screens/OrderBundles/screens/Edit'
import OrderBundlesList from './screens/OrderBundles/screens/List'
import PaginationRuleEdit from './screens/PaginationRules/screens/Edit'
import PaginationRulesList from './screens/PaginationRules/screens/List'
import PaymentMethodEdit from './screens/PaymentMethods/screens/Edit'
import PaymentMethodList from './screens/PaymentMethods/screens/List'
import PortalEdit from './screens/Portals/screens/Edit'
import PortalList from './screens/Portals/screens/List'
import PricingPlanList from './screens/PricingPlans/screens/List'
import ProcessingFeesAuditLog from './screens/ProcessingFees/screens/AuditLog'
import ProcessingFeesList from './screens/ProcessingFees/screens/List'
import ProductEdit from './screens/ServiceProducts/screens/Edit'
import ProductList from './screens/ServiceProducts/screens/List'
import ProviderEdit from './screens/Providers/screens/Edit'
import ProviderList from './screens/Providers/screens/List'
import ProviderAccountEdit from './screens/ProviderAccounts/screens/Edit'
import ProviderAccountList from './screens/ProviderAccounts/screens/List'
import OrderList from './screens/Orders/screens/List'
import ProviderPackageEdit from './screens/ProviderPackages/screens/Edit'
import ProviderPackageList from './screens/ProviderPackages/screens/List'
import ProviderPriceListEdit from './screens/ProviderPriceLists/screens/Edit'
import ProviderPriceListList from './screens/ProviderPriceLists/screens/List'
import ProviderProductCodeList from './screens/ProviderProductCodes/screens/List'
import PublicationEdit from './screens/Publications/screens/Edit'
import PublicationList from './screens/Publications/screens/List'
import Reporting from './screens/Reporting/screens/List'
import RolesList from './screens/Roles/screens/List'
import ServiceCategoryList from './screens/ServiceCategories/screens/List'
import ServiceList from './screens/Services/screens/List'
import SmsLogList from './screens/SmsLogs/screens/List'
import StatusList from './screens/Statuses/screens/List'
import SystemEdit from './screens/Systems/screens/Edit'
import SystemList from './screens/Systems/screens/List'
import TagList from './screens/Tags/screens/List'
import TaskList from './screens/Tasks/screens/List'
import TeamEdit from './screens/Teams/screens/Edit'
import TeamList from './screens/Teams/screens/List'
import TemplatePageCategoryList from './screens/TemplatePageCategories/screens/List'
import TrainingCourseEdit from './screens/TrainingCourses/screens/Edit'
import TrainingCourseList from './screens/TrainingCourses/screens/List'
import TrainingLessonEdit from './screens/TrainingLessons/screens/Edit'
import TrainingModuleEdit from './screens/TrainingModules/screens/Edit'
import UserEdit from './screens/Users/screens/Edit'
import UserList from './screens/Users/screens/List'

const SystemManagerRoutes = () => (
  <Routes>
    <Route path="/agencies" element={<AgencyList />} />
    <Route path="/agencies/:agencyId/edit/*" element={<AgencyEdit />} />
    <Route path="/apiLogs" element={<ApiLogList />} />
    <Route path="/assetLibraries" element={<AssetLibraryList />} />
    <Route path="/brandGroups" element={<BrandGroupList />} />
    <Route path="/brandGroups/:brandGroupId/edit/*" element={<BrandGroupEdit />} />
    <Route path="/brandThemes" element={<BrandThemeList />} />
    <Route path="/brands" element={<BrandList />} />
    <Route path="/brands/:brandId/edit/*" element={<BrandEdit />} />
    <Route path="/campaigns" element={<CampaignList />} />
    <Route path="/campaigns/:campaignId/edit/*" element={<CampaignEdit />} />
    <Route path="/courses" element={<TrainingCourseList />} />
    <Route path="/courses/:trainingCourseId/edit/*" element={<TrainingCourseEdit />} />
    <Route path="/fonts" element={<FontFamilyList />} />
    <Route path="/geoCountries" element={<GeoCountryList />} />
    <Route path="/geoCountries/:geoCountryId/edit/*" element={<GeoCountryEdit />} />
    <Route path="/geoSuburbs" element={<GeoSuburbList />} />
    <Route path="/imageLibraries" element={<ImageLibraryList />} />
    <Route path="/invoices" element={<InvoiceList />} />
    <Route path="/invoices/:invoiceId/edit/*" element={<InvoiceEdit />} />
    <Route path="/loginSessions" element={<LoginSessionList />} />
    <Route path="/notifications" element={<NotificationList />} />
    <Route path="/notifications/:notificationId/edit/*" element={<NotificationEdit />} />
    <Route path="/orderBundles" element={<OrderBundlesList />} />
    <Route path="/orderBundles/:orderBundleId/edit/*" element={<OrderBundleEdit />} />
    <Route path="/paginationRules" element={<PaginationRulesList />} />
    <Route path="/paginationRules/:paginationRuleId/edit/*" element={<PaginationRuleEdit />} />
    <Route path="/paymentMethods" element={<PaymentMethodList />} />
    <Route path="/paymentMethods/:paymentMethodId/edit/*" element={<PaymentMethodEdit />} />
    <Route path="/portals" element={<PortalList />} />
    <Route path="/portals/:portalId/edit/*" element={<PortalEdit />} />
    <Route path="/pricingPlans" element={<PricingPlanList />} />
    <Route path="/processingFees/auditLog" element={<ProcessingFeesAuditLog />} />
    <Route path="/processingFees" element={<ProcessingFeesList />} />
    <Route path="/products" element={<ProductList />} />
    <Route path="/products/:serviceProductId/edit/*" element={<ProductEdit />} />
    <Route path="/providerAgencies" element={<ProviderAccountList />} />
    <Route path="/providerAgencies/:agencyId/edit/*" element={<ProviderAccountEdit />} />
    <Route path="/orders" element={<OrderList />} />
    <Route path="/providerPackages" element={<ProviderPackageList />} />
    <Route path="/providerPackages/:providerPackageId/edit" element={<ProviderPackageEdit />} />
    <Route path="/providerPriceLists" element={<ProviderPriceListList />} />
    <Route path="/providerPriceLists/:providerPriceListId/edit/*" element={<ProviderPriceListEdit />} />
    <Route path="/providerProductCodes" element={<ProviderProductCodeList />} />
    <Route path="/providers" element={<ProviderList />} />
    <Route path="/providers/:providerId/edit/*" element={<ProviderEdit />} />
    <Route path="/publications" element={<PublicationList />} />
    <Route path="/publications/:publicationId/edit/*" element={<PublicationEdit />} />
    <Route path="/reporting" element={<Reporting />} />
    <Route path="/roles" element={<RolesList />} />
    <Route path="/serviceCategories" element={<ServiceCategoryList />} />
    <Route path="/services" element={<ServiceList />} />
    <Route path="/smsLogs" element={<SmsLogList />} />
    <Route path="/statuses" element={<StatusList />} />
    <Route path="/systems" element={<SystemList />} />
    <Route path="/systems/:systemId/edit/*" element={<SystemEdit />} />
    <Route path="/tags" element={<TagList />} />
    <Route path="/tasks" element={<TaskList />} />
    <Route path="/teams" element={<TeamList />} />
    <Route path="/teams/:teamId/edit/*" element={<TeamEdit />} />
    <Route path="/templateCategories" element={<TemplatePageCategoryList />} />
    <Route path="/trainingLessons/:trainingLessonId/edit/*" element={<TrainingLessonEdit />} />
    <Route path="/trainingModules/:trainingModuleId/edit/*" element={<TrainingModuleEdit />} />
    <Route path="/users" element={<UserList />} />
    <Route path="/users/:userId/edit/*" element={<UserEdit />} />
  </Routes>
)

export default SystemManagerRoutes
